<template>
  <div>
    <div class="search-wrapper">
      <div class="search-item">
        <span>部门：</span>
        <Select style="width:fit-content" multiple v-model="searchValue.department">
          <Option v-for="district in districts" :value="district.name" :key="district.id"></Option>
        </Select>
      </div>
      <div class="search-item">
        <span>姓名：</span>
        <Input style="width:150px" v-model="searchValue.manager"></Input>
      </div>
      <div class="search-item">
        <span>是否在职：</span>
        <Select style="width:100px" v-model="searchValue.isPresent">
          <Option v-for="item in isPresentArr" :key="item.item" :value="item.item" :label="item.label"></Option>
        </Select>
      </div>
      <div class="search-item">
        <span>业务范围：</span>
        <Select style="width:150px" v-model="searchValue.serviceType">
          <Option v-for="item in serviceTypeArr" :key="item.item" :value="item.item" :label="item.label"></Option>
        </Select>
      </div>
      <div class="search-item">
        <span>主管：</span>
        <Input style="width:150px" v-model="searchValue.leader"></Input>
      </div>
      <Button type="primary" @click="getList()">搜索</Button>
      <Button type="primary" @click="formVisible=true" style="margin-left:10px">新增</Button>
    </div>
    <Table :columns="columns" :data="managerList" style="min-width:1200px"></Table>
    <Page style="margin-top:5px;" :total="total" show-elevator :current="currentPage" @on-change="getList"></Page>
    <!-- 新增或编辑 -->
    <Modal v-model="formVisible" title="客户经理详情" :width="300">
      <p style="display:flex;align-items:center">
        <span class="label">所属部门：</span>
        <Select v-model="currentData.department" multiple>
          <Option v-for="district in districts" :value="district.name" :key="district.id">{{district.name}}</Option>
        </Select>
      </p>
      <p style="display:flex;margin-top:15px;align-items:center">
        <span class="label">客户经理：</span>
        <Input v-model="currentData.manager"></Input>
      </p>
      <p style="display:flex;margin-top:15px;align-items:center">
        <span class="label">是否在职：</span>
        <Select v-model="currentData.isPresent">
          <Option v-for="item in isPresentArr" :key="item.item" :value="item.item" :label="item.label"></Option>
        </Select>
      </p>
      <p style="display:flex;margin-top:15px;align-items:center">
        <span class="label">直属主管：</span>
        <Input v-model="currentData.leader"></Input>
      </p>
      <p style="display:flex;margin-top:15px;align-items:center">
        <span class="label">业务范围：</span>
        <Select v-model="currentData.serviceType">
          <Option v-for="item in serviceTypeArr" :key="item.item" :value="item.item" :label="item.label"></Option>
        </Select>
      </p>
      <div slot="footer">
        <Button style="margin-right:14px" @click="formVisible=false">取消</Button>
        <Button type="primary" @click="createOrEdit">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import { formatDate } from '@/lib/tool'

export default {
  data() {
    return {
      searchValue: {
        department: [],
        manager: '',
        isPresent: '',
        serviceType: '',
        leader: ''
      },
      managerList: [],
      columns: [
        {
          title: '部门',
          key: 'department'
        },
        {
          title: '客户经理',
          key: 'manager'
        },
        // {
        //   title: '账号',
        //   key: 'userName'
        // },
        {
          title: '是否在职',
          key: 'isPresent',
          render: (h, params) => {
            let isPresent = params.row.isPresent === 0 ? '否' : params.row.isPresent === 1 ? '是' : '/'
            return h('div', isPresent)
          }
        },
        {
          title: '业务范围',
          key: 'serviceType',
          render: (h, params) => {
            let serviceType = '/'
            switch (params.row.serviceType) {
              case 0: serviceType = '线上'; break
              case 1: serviceType = '线下'; break
              case 2: serviceType = '线上,线下'; break
            }
            return h('div', serviceType)
          }
        },
        {
          title: '直属主管',
          key: 'leader'
        },
        {
          title: '操作',
          key: "Actions",
          align: 'center',
          render: (h, params) => {
            let disabled = true
            if (this.flowStatus === 1) {
              disabled = false
            }
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    let department = params.row.department.split(',')
                    this.currentData = Object.assign({}, params.row)
                    this.currentData.department = department
                    this.formVisible = true
                  }
                }
              }, '编辑'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.deleteManager(params.row)
                  }
                }
              }, '删除')
            ]);
          }
        }
      ],
      currentPage: 1,
      total: 0,
      districts: [],
      formVisible: false,
      currentData: {},
      isPresentArr: [
        {
          label: '否',
          item: 0
        },
        {
          label: '是',
          item: 1
        }
      ],
      serviceTypeArr: [
        {
          label: '线上',
          item: 0
        },
        {
          label: '线下',
          item: 1
        },
        {
          label: '线上及线下',
          item: 2
        }
      ]
    }
  },
  created() {
    this.getDistrict()
    this.getList()
  },
  computed: {
    userInfo () {
      return this.$store.state.session.user
    }
  },
  watch: {
    formVisible (val) {
      if (!val) this.currentData = {}
    }
  },
  methods: {
    async getDistrict() {
      let rep = await ajax(requestUrls.CLDistrict.GetList)
      this.districts = []
      if (rep.data.success) {
        this.districts = rep.data.result.items
      }
    },
    // 获取代办数据
    async getList(page = 1) {
      this.currentPage = page
      let query = ''
      let manager = this.searchValue.manager ? ` and manager.Contains("${this.searchValue.manager}")` : ''
      let isPresent = this.searchValue.isPresent !== '' ? ` and isPresent == "${this.searchValue.isPresent}"` : ''
      let serviceType = this.searchValue.serviceType !== '' ? ` and serviceType == "${this.searchValue.serviceType}"` : ''
      let leader = this.searchValue.leader ? ` and leader.Contains("${this.searchValue.leader}")` : ''
      let department = ''
      this.searchValue.department.forEach(el => {
        department += ` or department.Contains("${el}")`
      })
      department = this.searchValue.department.length ? `(${department.slice(4)})` : ''
      query = department + manager + isPresent + serviceType + leader
      if (!this.searchValue.department.length) query = query.slice(5)
      let rep = await ajax.get(requestUrls.AbpDistrictManagers.GetPaged, {
        params: {
          filter: query,
          maxResultCount: 10,
          skipCount: (page - 1) * 10
        }
      })
      this.managerList = rep.data.result.items
      this.total = rep.data.result.totalCount
    },
    createOrEdit () {
      let abpDistrictManagers = Object.assign(this.currentData, {
        department: this.currentData.department ? this.currentData.department.toString() : ''
      })
      let query = !abpDistrictManagers.department || !abpDistrictManagers.manager || abpDistrictManagers.isPresent === undefined || !abpDistrictManagers.leader || abpDistrictManagers.serviceType === undefined
      if (query) {
        this.$Message.error('请完善信息！')
        return
      }
      ajax.post(requestUrls.AbpDistrictManagers.CreateOrUpdate,{
        abpDistrictManagers
      }).then(res => {
        this.$Message.success('操作成功')
        this.formVisible = false
        this.getList(this.currentPage)
      })
    },
    deleteManager (info) {
      this.$Modal.confirm({
        content: '是否确定删除该客户经理信息？',
        onOk: () => {
          ajax.delete(`${requestUrls.AbpDistrictManagers.Delete}?id=${info.id}`).then(res => {
            this.$Message.success('已删除')
            this.getList()
          })
        }
      })
    }
  }
}
</script>

<style lang="less" serviceTyped>
.label {
  display: inline-block;
  width: 100px;
}
.search-wrapper {
  display: flex;
  margin-bottom: 10px;
  flex-wrap: wrap;
  .search-item {
    margin-right: 10px;
  }
}
</style>
